import React from "react";
import { useSelector } from "react-redux";
import { State } from "store";
import { useTranslation } from "utilities/i18n";
import { useUserMeta } from "utilities/userMeta";
import { Layout } from "views/Main/Layouts";
import { ToggleSwitchInput, useFeatureFlagWithTenant } from "elements";

export const AccessibilitySettings: React.FC = () => {
  const { t } = useTranslation();
  const [setUserMeta] = useUserMeta();
  const { highContrastCharts } = useSelector((state: State) => state.userMeta);
  const [isAccessibilityMenuEnabled] = useFeatureFlagWithTenant(
    "ACCESSIBILITY_MENU"
  );

  if (!isAccessibilityMenuEnabled) {
    return null;
  }

  return (
    <Layout.Content>
      <Layout.Content.ScrollingList>
        <div className="card title-card">{t("ACCESSIBILITY_SETTINGS")}</div>
        <div className="form grid">
          <div className="form-group">
            <label className="col-3 text-right" htmlFor="highContrastCharts">
              {t("HIGH_CONTRAST_CHARTS")}
            </label>
            <ToggleSwitchInput
              className="col-3 vcenter"
              name="highContrastCharts"
              checked={!!highContrastCharts}
              onChange={() =>
                setUserMeta({ highContrastCharts: !highContrastCharts })
              }
            />
          </div>
        </div>
      </Layout.Content.ScrollingList>
    </Layout.Content>
  );
};
